<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_withdraws']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary"  @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button></div>
              </div>
              <span v-show="userData.permissions['new_withdraws']==1" class="mt-4"><b-button v-b-modal.new-withdraw variant="primary" type="button" class="btn-sm btn"><i class="mdi mdi-plus"></i> New Withdraw</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>

              <template #cell(amount)="data">
                {{ commas(data.item.amount) }}
              </template>
              <template #cell(charges)="data">
                {{ commas(data.item.charges) }}
              </template>
              <template #cell(reference)="data">
                {{ (data.item.reference) }}
              </template>
              <template #cell(mode_of_payment)="data">
                {{ data.item.mode_of_payment.name }}<br>
                <b class="text-info">{{ data.item.mode_of_payment.account_number }}</b>
              </template>
              <template #cell(approval)="data">
                  <span  class="text-info" v-if="data.item.status==2">
                    <b-button class="btn-sm" variant="light">Approved</b-button>
                  </span>
                  <span v-else>
                    <b-button v-show="userData.permissions['approve_withdraws']==1" @click="approve(data.item.id,data.item.member,data.item.amount,data.item.mode_of_payment,data.item.charges,data.item.reference,data.item.withdraw_date )" type="button" class="btn-sm" variant="primary" v-b-modal.edit>Approve</b-button>
                  </span>
                </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <router-link v-show="data.item.status==2" :to="{ path: '/printwithdraw',  query: { id: data.item.id }}"  type="button" class="btn-sm btn-dark" title="Print"> <i class="mdi mdi-printer"></i></router-link>
                  <b-button v-show="userData.permissions['edit_withdraws']==1" :disabled="data.item.status==2"  @click="edit(data.item.id,data.item.member.member_id,data.item.amount,data.item.mode_of_payment.id,data.item.charges,data.item.reference,data.item.withdraw_date )" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button v-show="userData.permissions['delete_withdraws']==1" :disabled="data.item.status==2" @click="remove(data.item.id,data.item.member.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                  <b>Total Withdraws : {{ commas(totalwithdraws) }}</b>
                </div>
              <div class="col">
                <b>Total Charges : {{ commas(totalcharges) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Withdraws</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-withdraw" centered title="New Withdraw" title-class="font-18" hide-footer>
        <form @submit.prevent="addWithdraw">
            <div class="form-group mb-2">
              <label>Member</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="member" label="name" :reduce="member => member.member_id" @input="FindBalance()"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Standing Balance</label>
            <input v-model="savingbalance" type="text" readonly class="form-control" />
            </div>
            <div class="row">
            <div class="form-group col-6">
            <label>Withdraw Amount</label>
            <input v-model="amount" :max="savingbalance" @input="FindCharge()" type="number" class="form-control" />
            </div>
            <div class="form-group col-6">
            <label>Charges</label>
            <input v-model="charges" readonly class="form-control"/>
            </div>
          </div>
            <div class="form-group mb-2">
            <label>Reference</label>
            <textarea  v-model="reference" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
              <label>Mode of Transaction</label> <small class="text-danger">*</small>
                <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name" :reduce="mode_of_payment => mode_of_payment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Withdraw Date</label>
            <input v-model="withdraw_date" :max="currentdate" type="date" class="form-control" />
            </div>
            <br>
            <small class="text-danger">{{ chargesError }}</small><br>
            <small class="text-danger">{{ loanError }}</small>
            <div class="form-group d-flex justify-content-end">
                <span class="text-danger me-3 fw-bold mt-2" v-if="availabeWithdraws">{{ withdraw_error }}</span>
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-withdraw')" >Close</b-button>
                <b-button type="submit" :disabled="saveBtn || availabeWithdraws" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

     <b-modal id="edit-withdraw" centered title="Edit Withdraw" title-class="font-14" hide-footer>
        <form @submit.prevent="editWithdraw">
          <div class="form-group mb-2">
              <label>Member</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="member" label="name" :reduce="member => member.member_id" @input="FindBalance()"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Standing Balance</label>
            <input v-model="savingbalance" type="text" readonly class="form-control" />
            </div>
            <div class="row">
            <div class="form-group col-6">
            <label>Withdraw Amount</label>
            <input v-model="amount" :max="savingbalance" @input="FindCharge()" type="number" class="form-control" />
            </div>
            <div class="form-group col-6">
            <label>Charges</label>
            <input v-model="charges" readonly class="form-control"/>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>Reference</label>
            <textarea  v-model="reference" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
              <label>Mode of Transaction</label> <small class="text-danger">*</small>
                <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name" :reduce="mode_of_payment => mode_of_payment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Withdraw Date</label>
            <input v-model="withdraw_date" :max="currentdate" type="date" class="form-control" />
            </div>
            <br>
            <small class="text-danger">{{ chargesError }}</small><br>
            <small class="text-danger">{{ loanError }}</small>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-withdraw')" >Close</b-button>
                <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="approve-withdraw" centered title="Are you sure you want to Approve Withdraw" title-class="font-14" hide-footer>
        <form @submit.prevent="approveWithdraw">
          <div class="form-group mb-2">
              <label>Member : </label> 
              <h5 ><span class="text-info h5" v-html="member"></span> - <span class="text-info h5" v-html="membername"></span></h5>
            </div>
            <div class="form-group mb-2">
            <label>Withdraw Amount</label>
              <h5 class="text-info" v-html="commas(amount)"></h5>
            </div>
            <div class="form-group mb-2">
              <label>Mode of Transaction</label> 
              <h5 class="text-info" v-html="mode_of_payment"></h5>
            </div>
            <div class="form-group mb-2">
            <label>Charges</label>
              <h5 class="text-info" v-html="charges"></h5>
            </div>
            <div class="form-group mb-2">
            <label>Reference</label>
              <h5 class="text-info" v-html="reference"></h5>
            </div>
            <div class="form-group mb-2">
            <label>Withdraw Date</label>
              <h5 class="text-info" v-html="withdraw_date"></h5>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('approve-approve')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

     <b-modal id="delete-withdraw" centered title="Delete Withdraw" title-class="font-18" hide-footer>
        <form @submit.prevent="removeWithdraw">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Withdraw for : <b>{{ membername }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-withdraw')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { withdrawMethods, withdrawComputed, memberMethods, memberComputed, paymentoptionMethods, paymentoptionComputed} from "@/state/helpers";

export default {
  page: {
    title: "Withdraws",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Withdraws",
      items: [ {text: "Dashboard",to: "/",}, {text: "Withdraws",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'member', label: 'Name', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'charges', label: 'Charges', visible: true },
          { key: 'mode_of_payment', label: 'Mode of Transaction', visible: true },
          { key: 'reference', label: 'Reference', visible: true },
          { key: 'withdraw_date', label: 'Withdraw Date', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'approval', label: 'Approval', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      member:'',
      amount:'',
      mode_of_payment:'',
      charges:'',
      reference:'',
      withdraw_date:new Date().toLocaleDateString('fr-CA'),
      membername:'',
      saveBtn:true,
      saveError:'',
      loanError:'',
      chargesError:'',
      savingbalance:'',
      currentdate:new Date().toLocaleDateString('fr-CA'),
      date_to:new Date().toLocaleDateString('fr-CA'),
      date_from:new Date().toLocaleDateString('fr-CA'),
      name_hover: false,
      current_index: null,
      withdraw_error: 'Member has a pending withdraw',
    };
  },
  computed: {
    ...withdrawComputed,
    ...memberComputed,
    ...paymentoptionComputed,
    List() { return this.withdraws.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.withdraws.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.withdraws.length>0) { a=false;} else { a=true;} return a },
    totalwithdraws(){ var total = 0; this.withdraws.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
    totalcharges(){ var total = 0; this.withdraws.forEach((item)=>{ var item_total = item.charges; total = Number(total)+Number(item_total);}); return total },
    availabeWithdraws() {
      return this.withdraws.some(withdraw => withdraw.member.member_id == this.member && withdraw.status == 1);
    },
  },
  mounted() {
    this.fetchWithdraws();
    this.fetchMembers();
    this.fetchPaymentoptions();
    this.TotalRows = this.withdraws.length;
    this.isBusy=false;
  },
  methods: {
    ...withdrawMethods,
    ...memberMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async FindBalance(){
      let url = `/savingsbalance/${this.member}`;
      await axios.get(url).then((response) => {
        this.savingbalance = response.data.balance;
        this.loanError= response.data.error;
      });
    },
    async FindCharge(){
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("balance", this.savingbalance);
      let url = "/findcharges";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.charges=response.data.charges;
          this.chargesError=response.data.error;
          this.saveBtn=response.data.errorstatus;
      }
      });
    },
    async addWithdraw() {
      this.saveBtn=true;
      this.saveError="Saving Member Withdraws";
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("charges", this.charges);
      formData.append("reference", this.reference);
      formData.append("withdraw_date", this.withdraw_date);
      let url = "/addwithdraw";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchWithdraws();
          this.$bvModal.hide('new-withdraw');
          this.member="";
          this.amount="";
          this.savingbalance="";
          this.mode_of_payment="";
          this.charges="";
          this.reference="";
          this.$toast.info("New Member Withdraw Added");
          this.saveBtn=false;
          this.saveError="";
      }
      });
    },
    edit(id,member,amount,mode_of_payment,charges,reference,withdraw_date){
      this.id=id;
      this.member=member;
      this.amount=amount;
      this.mode_of_payment=mode_of_payment;
      this.charges=charges;
      this.reference=reference;
      this.withdraw_date=withdraw_date;
      this.$bvModal.show('edit-withdraw')
    },
    approve(id,member,amount,mode_of_payment,charges,reference,withdraw_date){
      this.id=id;
      this.member=member.member_id;
      this.membername=member.name;
      this.amount=amount;
      this.mode_of_payment=mode_of_payment.name;
      this.charges=charges;
      this.reference=reference;
      this.withdraw_date=withdraw_date;
      this.$bvModal.show('approve-withdraw')
    },
    remove(id,member){
      this.id=id;
      this.membername=member;
      this.$bvModal.show('delete-withdraw')
    },
   
    async editWithdraw(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("member", this.member);
    formData.append("amount", this.amount);
    formData.append("mode_of_payment", this.mode_of_payment);
    formData.append("charges", this.charges);
    formData.append("reference", this.reference);
    formData.append("withdraw_date", this.withdraw_date);
    let url = "/updatewithdraw";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchWithdraws();
        this.$bvModal.hide('edit-withdraw');
        this.member="";
        this.amount="";
        this.charges="";
        this.reference="";
      }
    });
    },
    async approveWithdraw(){
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/approvewithdraw";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchWithdraws();
        this.$bvModal.hide('approve-withdraw');
      }
    });
    },
    async removeWithdraw() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removewithdraw";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchWithdraws();
        this.$bvModal.hide('delete-withdraw');
      }
    });
    },
    FilterData() {
        this.filterWithdraws({datefrom:this.date_from,dateto:this.date_to});
      },
  },
};
</script>